import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=9af5bb4c&scoped=true&"
import script from "./Sorting.vue?vue&type=script&lang=js&"
export * from "./Sorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af5bb4c",
  null
  
)

export default component.exports